import { UserRoles } from '../../enum/UserRoles';

export const navigateByRole = (userType: UserRoles, isGlobalBrandActive?: boolean) => {
    switch (userType) {
        case UserRoles.INFLUENCER:
            return '/influencer/dashboard';
        case UserRoles.AGENCY:
        case UserRoles.AGENCY_MASTER:
            return '/agency/influencers';
        case UserRoles.BRAND:
        case UserRoles.BRAND_MASTER:
            return isGlobalBrandActive ? '/brand/global/dashboard' : '/brand/dashboard';
        default:
            return '/';
    }
};
